export default __webpack_public_path__ + "static/logo-0418428251f1616657063cc37273d118.svg";